<template>
  <div>
    <v-card class="mx-1" max-width="100%" tile>
      <div class="pa-3 top-row">
        <v-btn text color="primary" :loading="loading" :to="{ name: 'art-info-links-new' }"> Ny länk </v-btn>
      </div>
      <draggable v-model="internalLinks" handle=".drag-icon" ghost-class="ghost" @change="onChangeOrder">
        <v-list-item v-for="link in internalLinks" :key="link.id" class="item">
          <v-list-item-content>
            <div class="item-content">
              <div>
                {{ link.name_sve }}
                <a :href="link.url" target="_blank">
                  <span class="ml-2 grey--text text--lighten-1">{{ link.url }}</span></a
                >
              </div>
              <div class="context">
                <v-icon
                  class="mr-2 edit-icon"
                  @click="
                    $router.push({ name: 'art-info-links-edit', params: { linkId: link.id } })
                  "
                  >mdi-pen</v-icon
                >
                <v-icon @click="onLinkDelete(link)">mdi-trash-can</v-icon>
                <v-icon class="drag-icon">mdi-drag-vertical</v-icon>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </draggable>
    </v-card>
    <router-view @link:add="onLinkAdd" @link:edit="onLinkEdit" :links="links" :key="$route.name" />
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'InfoLinks',
  props: {
    links: { type: Array },
    loading: { type: Boolean },
  },
  components: {
    draggable,
  },
  data() {
    return {
      internalLinks: [],
      hasReordered: false,
    }
  },
  watch: {
    links: {
      deep: true,
      handler(links) {
        this.internalLinks = links.length ? [...links].sort((a, b) => a.sort - b.sort) : []
      },
    },
  
  },
  created(){
    return this.internalLinks = this.links.length ? [...this.links].sort((a, b) => a.sort - b.sort) : []
  },
  computed: {},
  methods: {
    onChangeOrder(){
      const payload = { links: [...this.internalLinks.map((link, i) => ({ ...link, sort: i }))] }
      this.$emit('change:links:order', payload)
    },
    onLinkEdit(link) {
      const index = this.internalLinks.findIndex((links) => links.id === link.id)
      this.internalLinks[index] = link
      const payload = { links: [...this.internalLinks.map((link, i) => ({ ...link, sort: i }))] }
      this.$emit('change:links', payload)
    },
    onLinkAdd(link) {
      this.internalLinks.push(link)
      const payload = { links: [...this.internalLinks.map((link, i) => ({ ...link, sort: i }))] }
      this.$emit('change:links', payload)
    },
    onLinkDelete({ id }) {
      const links = [...this.internalLinks]
      const payload = { links: [...links.filter((link) => link.id !== id)] }
      this.$emit('change:links', payload)
    },
  },
}
</script>

<style lang="less" scoped>
a {
  color: unset !important;
  text-decoration: none !important;
}
.top-row {
  display: flex;
  justify-content: flex-end;
}
.item {
  border-bottom: #cecece 1px solid;
  &:first-child {
    border-top: #cecece 1px solid;
  }
  .item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .drag-icon {
      cursor: grab;
    }
    .edit-icon {
      cursor: pointer;
    }
  }
}
.ghost {
  opacity: 0.9;
  background: #cecece;
}
.context{
  display: flex;
}
</style>
